module.exports = __webpack_public_path__ + "assets/yingtao.45df1524.svg";